"use strict";

define('rs/models/tenant',['rs/models/abstract', 'rs/models/organization', 'rs/models/sponsor.category', 'rs/models/group', 'rs/helper'], function (AbstractModel, OrganizationModel, SponsorCategoryModel, GroupModel, helper) {
  var Tenant = AbstractModel.extend({
    properties: ['activityDate', 'categories', 'formLists', 'organizations', 'parentId', 'tenants', 'updateUser', 'version', 'groups', 'acronym'],
    serverProperties: ['id', 'name', 'description'],
    tenant: true,
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setCategories([]);
      this.setOrganizations([]);
      this.setTenants([]);
    },
    newGroup: function newGroup(data) {
      return GroupModel.createGroup(data).bind(this).tap(function (group) {
        if (group instanceof GroupModel) {
          this.getGroups().push(group);
        }
      });
    },
    newTenant: function newTenant(data) {
      return this.constructor.createTenant(data).bind(this).tap(function (tenant) {
        if (tenant instanceof Tenant) {
          this.getTenants().push(tenant);
        }
      });
    },
    newChildOrganization: function newChildOrganization(data) {
      return OrganizationModel.createOrganization(data).bind(this).tap(function (org) {
        if (org instanceof OrganizationModel) {
          this.getOrganizations().push(org);
        }
      });
    },
    findOrganization: function findOrganization(id) {
      return helper.findObjectByProperty(this, 'organizations', 'id', id);
    },
    getFilteredOrganizationsList: function getFilteredOrganizationsList(id) {
      var flatList = [],
        _retrieveFlatList = function retrieveFlatList(n) {
          var children = n.getOrganizations();
          for (var i = 0; i < children.length; i++) {
            if (children[i].getId() == id) {
              continue;
            }
            flatList.push(children[i]);
            _retrieveFlatList(children[i]);
          }
        };
      _retrieveFlatList(this);
      return flatList;
    },
    getTitle: function getTitle() {
      return this.getName() || 'Root';
    },
    remove: function remove() {
      return this.constructor.deleteTenant(this.getId());
    },
    requestDetails: function requestDetails() {
      if (this.hasDetails) {
        return Promise.resolve(this);
      } else {
        return this.constructor.requestDetails(this.getId()).bind(this).then(function (data) {
          this.hasDetails = true;
          this.applyProperties(data);
          return Promise.resolve(this);
        });
      }
    },
    requestGroups: function requestGroups(options) {
      var that = this;
      return GroupModel.requestGroups(options).tap(function (groups) {
        that.setGroups(groups);
      });
    },
    requestCategories: function requestCategories() {
      return SponsorCategoryModel.requestCategories().bind(this).tap(function (categories) {
        this.setCategories(categories);
      });
    },
    requestOrganizations: function requestOrganizations() {
      return OrganizationModel.requestOrganizations({
        full: true
      }).bind(this).tap(function (orgs) {
        this.setOrganizations(orgs);
      });
    },
    requestTenants: function requestTenants() {
      return this.constructor.requestTenants().bind(this).tap(function (tenants) {
        this.setTenants(tenants);
      });
    },
    requestFormLists: function requestFormLists() {
      return Promise.join(this.constructor.requestAddressTypes(), this.constructor.requestEmailTypes(), this.constructor.requestPhoneTypes(), this.constructor.requestCountries()).bind(this).spread(function (addressTypes, emailTypes, phoneTypes, countryList) {
        var formLists = {
          countries: countryList,
          addressTypes: addressTypes,
          emailTypes: emailTypes,
          phoneTypes: phoneTypes
        };
        this.setFormLists(formLists);
        return formLists;
      });
    },
    update: function update(newData) {
      this.hasDetails = false;
      this.applyProperties(newData);
      return this.constructor.updateTenant(this).bind(this).tap(function (data) {
        this.hasDetails = true;
        this.applyProperties(data);
      });
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#tenant(?*query)': function getTenantQuery(data) {
        return this.models(data);
      },
      '#post#tenant': function postTenant(data) {
        return this.model(data);
      },
      'customer': function customer(data) {
        data.id = data.id || 0;
        return this.model(data);
      }
    },
    createTenant: function createTenant(data) {
      return this.post('tenant', data, {
        jsonBody: true
      });
    },
    deleteTenant: function deleteTenant(id) {
      return this.del('tenant/' + id);
    },
    getRoot: function getRoot() {
      return new Tenant({
        id: 0,
        name: '',
        parentId: null
      });
    },
    model: function model(data) {
      return new Tenant(data);
    },
    requestCustomer: function requestCustomer() {
      return this.get('customer');
    },
    requestDetails: function requestDetails(id) {
      return this.get('tenant/' + id);
    },
    requestAddressTypes: function requestAddressTypes() {
      return this.get('type/address');
    },
    requestEmailTypes: function requestEmailTypes() {
      return this.get('type/email');
    },
    requestPhoneTypes: function requestPhoneTypes() {
      return this.get('type/telephone');
    },
    requestCountries: function requestCountries() {
      return this.get('country');
    },
    requestStates: function requestStates(countryId) {
      return this.get('country/' + countryId + '/province');
    },
    requestTenants: function requestTenants(params) {
      return this.get('tenant', params);
    },
    updateTenant: function updateTenant(data) {
      return this.put('tenant/' + data.getId(), data);
    }
  });
  return Tenant;
});

